import styled from 'styled-components';

export const PhoneBookCardWrapper = styled.div`
  background-color: #F4F4F5;
  padding: 15px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const Icon = styled.img`
  width: 32px;
  height: 32px;
`;

export const Title = styled.span`
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
  margin-bottom:5px
  color: #000000;
`;

export const Number = styled.span`
  font-size: 22px;
  line-height: 1.2;
  font-weight: 500;
  margin-bottom:5px
  color: #000000;
`;

export const Description = styled.span`
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  color: #3F3F46;
`;
